import { makeBillingRequest } from 'api'
import { showBillingErrorMessage } from 'utils'
import { message } from 'antd'
import { getSubscription } from 'store/authSlice/authActions'
import { billingActions } from './billingReducer'

export const getBillingTiers = (organizationId) => (dispatch) => {
  // If organizationId is provided, api will all non custom tiers plus custom tier for the organization
  // If organizationId is not provided, api will return all non custom tiers
  dispatch(billingActions.setLoading({ fetchingTiers: true }))
  makeBillingRequest('get', `/tiers`, {
    organizationId,
  })
    .then((res) => {
      if (res?.data) {
        dispatch(billingActions.setTiers(res?.data))
      } else {
        dispatch(billingActions.setTiers([]))
      }
      dispatch(billingActions.setLoading({ fetchingTiers: false }))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setTiers([]))
      dispatch(billingActions.setLoading({ fetchingTiers: false }))
    })
}

export const createBillinSubscription =
  (organizationId, payload) => (dispatch) => {
    dispatch(billingActions.setLoading({ creatingSubscription: true }))
    makeBillingRequest(
      'post',
      `/subscription`,
      {
        organizationId,
      },
      payload,
    )
      .then((res) => {
        message.success(res.message || 'Successfully subscribed')
        dispatch(billingActions.setLoading({ creatingSubscription: false }))
        dispatch(billingActions.setTier(null))
        dispatch(getBillingSubscription(organizationId))
      })
      .catch((error) => {
        showBillingErrorMessage(error)
        dispatch(billingActions.setLoading({ creatingSubscription: false }))
      })
  }

export const getBillingSubscription = (organizationId) => (dispatch) => {
  dispatch(billingActions.setLoading({ fetchingSubscription: true }))
  makeBillingRequest('get', `/subscription`, { organizationId })
    .then((res) => {
      if (res?.data) {
        dispatch(billingActions.setSubscription(res?.data))
      } else {
        dispatch(billingActions.setSubscription(null))
      }
      dispatch(billingActions.setLoading({ fetchingSubscription: false }))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setSubscription(null))
      dispatch(billingActions.setLoading({ fetchingSubscription: false }))
    })
}

export const updateBillingTier = (organizationId, payload) => (dispatch) => {
  dispatch(billingActions.setLoading({ updatingTier: true }))
  makeBillingRequest(
    'put',
    `/subscription/update-tier`,
    { organizationId },
    payload,
  )
    .then((res) => {
      message.success(res.message || 'Successfully updated subscription')
      dispatch(billingActions.setLoading({ updatingTier: false }))
      dispatch(getBillingSubscription(organizationId))
      dispatch(getSubscription(organizationId))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setLoading({ updatingTier: false }))
    })
}

export const updateBillingPaymentMethod =
  (organizationId, payload) => (dispatch) => {
    dispatch(billingActions.setLoading({ updatingPaymentMethod: true }))
    makeBillingRequest(
      'put',
      `/subscription/update-payment-method`,
      { organizationId },
      payload,
    )
      .then((res) => {
        message.success(res.message || 'Successfully updated payment method')
        dispatch(billingActions.setLoading({ updatingPaymentMethod: false }))
        dispatch(getBillingSubscription(organizationId))
      })
      .catch((error) => {
        showBillingErrorMessage(error)
        dispatch(billingActions.setLoading({ updatingPaymentMethod: false }))
      })
  }

export const cancelBillingSubscription = (organizationId) => (dispatch) => {
  dispatch(billingActions.setLoading({ cancellingSubscription: true }))
  makeBillingRequest('put', `/subscription/cancel`, { organizationId })
    .then((res) => {
      message.success(res.message || 'Successfully cancelled subscription')
      dispatch(billingActions.setLoading({ cancellingSubscription: false }))
      dispatch(getBillingSubscription(organizationId))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setLoading({ cancellingSubscription: false }))
    })
}

export const renewBillingSubscription = (organizationId) => (dispatch) => {
  dispatch(billingActions.setLoading({ renewingSubscription: true }))
  makeBillingRequest('put', `/subscription/renew`, { organizationId })
    .then((res) => {
      message.success(res.message || 'Successfully renewed subscription')
      dispatch(billingActions.setLoading({ renewingSubscription: false }))
      dispatch(getBillingSubscription(organizationId))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setLoading({ renewingSubscription: false }))
    })
}

export const getBillingHistory = (organizationId) => (dispatch) => {
  dispatch(billingActions.setLoading({ fetchingHistory: true }))
  makeBillingRequest('get', `/info/history`, { organizationId })
    .then((res) => {
      if (res?.data) {
        dispatch(billingActions.setHistory(res?.data))
      } else {
        dispatch(billingActions.setHistory([]))
      }
      dispatch(billingActions.setLoading({ fetchingHistory: false }))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setHistory([]))
      dispatch(billingActions.setLoading({ fetchingHistory: false }))
    })
}

export const getMessagingCharges = (organizationId) => (dispatch) => {
  dispatch(billingActions.setLoading({ fetchingMessagingCharges: true }))
  makeBillingRequest('get', `/info/messaging-charges`, { organizationId })
    .then((res) => {
      if (res?.data) {
        dispatch(billingActions.setMessagingCharges(res?.data))
      } else {
        dispatch(billingActions.setMessagingCharges([]))
      }
      dispatch(billingActions.setLoading({ fetchingMessagingCharges: false }))
    })
    .catch((error) => {
      showBillingErrorMessage(error)
      dispatch(billingActions.setMessagingCharges([]))
      dispatch(billingActions.setLoading({ fetchingMessagingCharges: false }))
    })
}
